var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 13.5C11.301 13.5 10.7096 13.258 10.2256 12.774C9.74162 12.29 9.49962 11.6987 9.49962 11V5C9.49962 4.30133 9.74162 3.71 10.2256 3.226C10.7096 2.742 11.301 2.5 11.9996 2.5C12.6983 2.5 13.2896 2.742 13.7736 3.226C14.2576 3.71 14.4996 4.30133 14.4996 5V11C14.4996 11.6987 14.2576 12.29 13.7736 12.774C13.2896 13.258 12.6983 13.5 11.9996 13.5ZM11.2496 20V17.4538C9.76112 17.2819 8.48545 16.6704 7.42262 15.6193C6.35995 14.5679 5.73753 13.2865 5.55537 11.775C5.52853 11.5622 5.58428 11.3798 5.72262 11.228C5.86112 11.076 6.03678 11 6.24962 11C6.46245 11 6.64062 11.0734 6.78412 11.2203C6.92778 11.3669 7.02337 11.5467 7.07087 11.7595C7.25287 12.984 7.81278 13.9968 8.75062 14.798C9.68845 15.5993 10.7715 16 11.9996 16C13.2445 16 14.3316 15.5952 15.2611 14.7855C16.1906 13.976 16.7464 12.9673 16.9284 11.7595C16.9759 11.5467 17.0715 11.3669 17.2151 11.2203C17.3586 11.0734 17.5368 11 17.7496 11C17.9625 11 18.1381 11.076 18.2766 11.228C18.415 11.3798 18.4707 11.5622 18.4439 11.775C18.2617 13.2532 17.6435 14.5247 16.5891 15.5895C15.5346 16.6542 14.2548 17.2756 12.7496 17.4538V20C12.7496 20.2128 12.6778 20.391 12.5341 20.5345C12.3906 20.6782 12.2125 20.75 11.9996 20.75C11.7868 20.75 11.6086 20.6782 11.4651 20.5345C11.3215 20.391 11.2496 20.2128 11.2496 20Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicFill);
export default __webpack_public_path__ + "static/media/mic_fill.917ec7d795834bf0a6505e83f070e43a.svg";
export { ForwardRef as ReactComponent };